import {
  PopoverMenu,
  withConfirmation,
} from '@frontendmentorio/design-system-v2';

const ConfirmPopoverMenuItem = withConfirmation(PopoverMenu.Item);

export default ConfirmPopoverMenuItem;
